import { LazyLoadSelect } from "common/LazyLoadSelect";

import * as S from "../styled";

export const EvidenceSidebarSelects = ({ selects, selectedOptions, subjectProperty, handleSelectChange }) => {
  return (
    <S.MultiSelectWrapper>
      {(Array.isArray(selects) ? selects : []).map((selectItem) => {
        const options = [];

        if (Array.isArray(selectItem?.data)) {
          for (const value of selectItem.data) {
            options.push({ tooltip: value, value, label: value, className: value === subjectProperty?.[selectItem?.description] ? "!hidden" : undefined, });
          }
        } else {
          for (const [key, value] of Object.entries(selectItem.data)) {
            options.push({ tooltip: value, value: key, label: value, className: key === subjectProperty?.[selectItem?.description] ? "!hidden" : undefined, });
          }
        }

        options.sort((a, b) => {
          const getPrefix = (val) => {
            const match = val.match(/^\d+/); // extract leading digits
            return match ? parseInt(match[0], 10) : Infinity;
          };
          return getPrefix(a.value) - getPrefix(b.value);
        });

        const selected = selectedOptions?.[selectItem?.description];

        let selectedValue;
        if (!selectItem.is_associative && subjectProperty) {
          selectedValue = selectItem.data.find((item) =>
            item.startsWith(subjectProperty[selectItem.description] + " ")
          );
        }

        let subject = {};

        if (subjectProperty) {
          if (selectedValue) {
            subject = {
              label: selectedValue,
              value: selectedValue
            };
          } else if (selectItem.is_associative) {
            subject = {
              label: selectItem.data[subjectProperty[selectItem.description]],
              value: subjectProperty[selectItem.description]
            };
          } else {
            subject = {
              label: subjectProperty[selectItem.description],
              value: subjectProperty[selectItem.description]
            };
          }
        } else {
          subject = {
            label: "",
            value: "",
          };
        }

        return (
          <LazyLoadSelect
            key={selectItem.description}
            resetFilterOnHide
            description={
              selectItem.description === "market_area_code" && subjectProperty
                ? subjectProperty[selectItem.description]?.trim().split(" ")[0]
                : subjectProperty
                  ? subjectProperty[selectItem.description]?.trim()
                  : ""
            }
            itemTemplate={(option) => <div title={option.label}>{option.label}</div>}
            label={selectItem.name}
            optionLabel="label"
            options={options}
            panelHeaderTemplate={(options) => {
              const isChecked = selectedOptions?.[selectItem.description]?.includes(subject.value);

              return (
                <S.TemplateContainer>
                  <S.FilterContainer className="p-multiselect-header p-multiselect-filter-container">
                    {options.filterElement}
                  </S.FilterContainer>
                  {subject.value ? (
                    <S.SelectedSubjectContent>
                      <S.TemplateTitle>Selected / Subject</S.TemplateTitle>
                      <S.TemplateContent
                        onClick={() => {
                          if (isChecked) {
                            handleSelectChange(
                              selectItem.description,
                              selectedOptions[selectItem.description]?.filter(
                                (val) => val !== subject.value
                              )
                            );
                          } else {
                            handleSelectChange(selectItem.description, [
                              ...(selectedOptions[selectItem.description] || []),
                              subject.value,
                            ]);
                          }
                        }}
                      >
                        <input
                          readOnly
                          checked={isChecked}
                          className="p-checkbox-box checkbox"
                          type="checkbox"
                        />
                        <S.SubjectSpan title={subject.label}>
                          {subject.label} <S.Paragraph>subject</S.Paragraph>
                        </S.SubjectSpan>
                      </S.TemplateContent>
                      <S.SubjectBorder />
                    </S.SelectedSubjectContent>
                  ) : null}
                </S.TemplateContainer>
              );
            }}
            placeholder="select"
            selectedOptions={selected}
            setSelectedOptions={(newOptions) => handleSelectChange(selectItem.description, newOptions)}
            subjectValue={subject.value}
          />
        );
      })}
    </S.MultiSelectWrapper>
  );
};